<template>
  <v-container fluid class="down-top-padding">
    <base-breadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></base-breadcrumb>
    <base-card heading="Editar Avaliação">
      <form-exam-database action="edit"></form-exam-database>
    </base-card>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    page: {
      title: 'Editar Avaliação'
    },
    breadcrumbs: [
      {
        text: 'Início',
        disabled: false,
        to: '/'
      },
      {
        text: 'Avaliação',
        disabled: false,
        to: '/exam/list'
      },
      {
        text: 'Editar Avaliação',
        disabled: false,
        to: '/exam/add'
      }
    ]
  })
}
</script>
